import * as jsPdf from 'jspdf';
import { EInputMask } from "src/Components/EInput";
import { ITest } from "src/Interfaces/TestInterface";
import { IWell, IWellCloseReview, IWellCloseReviewProduct } from "src/Interfaces/WellInterface";
import { equalGrid } from "../MudReport/DrawReportMud";
import { fillEmptyRows } from "../MudReport/PopDataMud";
import { textArrayInBoxes } from "../PopulateDataMethods";
import { drawHeader } from "../VolumeAccountingReport/DrawReportVolume";
import * as MM from './SpecMilsWellCloseSnapshot';

const mask = new EInputMask();
export const createProductInventorySnapshotReport = (test: ITest, well: IWell, wellCloseReview: IWellCloseReview, logoBlob: HTMLImageElement, volumeReport: jsPdf) => {
    volumeReport.setFillColor(MM.HEADER_COLOR);
    popReport(test, well, wellCloseReview, logoBlob, volumeReport);
};

const popReport = (test: ITest, well: IWell, wellCloseReview: IWellCloseReview, logoBlob: HTMLImageElement, volumeReport: jsPdf) => {
    drawHeader(test, well, logoBlob, volumeReport);
    drawTotals(wellCloseReview, volumeReport);
    let count = drawProductsTable(wellCloseReview, 0, volumeReport);
    while (count < wellCloseReview.products.length)
    {
        volumeReport.addPage();
        drawHeader(test, well, logoBlob, volumeReport);
        count = drawProductsTable(wellCloseReview, count - 1, volumeReport);
    }
    volumeReport.addPage();
    drawHeader(test, well, logoBlob, volumeReport);
    drawTotals(wellCloseReview, volumeReport);
    count = drawExpenseTable(wellCloseReview, 0, volumeReport);
    while (count < wellCloseReview.expenses.length)
    {
        volumeReport.addPage();
        drawHeader(test, well, logoBlob, volumeReport);
        count = drawExpenseTable(wellCloseReview, count - 1, volumeReport);
    }
};

const drawTotals = (wellCloseReview: IWellCloseReview, wellCloseReport: jsPdf) => {
    const headers = [
        ['Product Total', 'Product Tax', 'EBP Costs', 'EBP Costs Tax', 'Well Total'],
        [undefined],
        ['Adjusted Product Total', 'Adjusted Product Tax', 'Adjusted EBP Costs', 'Adjusted EBP Costs Tax', 'Adjusted Well Total'],
        [undefined],
        [...Array(3), 'Total Difference (%)', 'Total Difference ($)'],
        [undefined]
    ];

    const data = [
        [undefined],
        [
            mask.currency(wellCloseReview.productTotal),
            mask.currency(wellCloseReview.productTax),
            mask.currency(wellCloseReview.otherCosts),
            mask.currency(wellCloseReview.otherCostTax),
            mask.currency(wellCloseReview.wellTotal),
        ],
        [undefined],
        [
            mask.currency(wellCloseReview.adjustedProductTotal),
            mask.currency(wellCloseReview.adjustedProductTax),
            mask.currency(wellCloseReview.adjustedOtherCosts),
            mask.currency(wellCloseReview.adjustedOtherCostTax),
            mask.currency(wellCloseReview.adjustedWellTotal),
        ],
        [undefined],
        [
            ...Array(3),
            wellCloseReview.totalDifferencePercent.toFixed(2) + '%',
            mask.currency(wellCloseReview.totalDifferenceCost),
        ]
    ];
    wellCloseReport.setFillColor(MM.HEADER_COLOR);
    wellCloseReport.rect(MM.TOTALS_LEFT, MM.TOTALS_TOP, MM.TOTALS_WIDTH, MM.TOTALS_HEIGHT / 6, 'f');
    let tempTop = MM.TOTALS_TOP + MM.TOTALS_HEIGHT / 3;
    wellCloseReport.rect(MM.TOTALS_LEFT, tempTop, MM.TOTALS_WIDTH, MM.TOTALS_HEIGHT / 6, 'f');
    tempTop += MM.TOTALS_HEIGHT / 3;
    wellCloseReport.rect(MM.TOTALS_LEFT, tempTop, MM.TOTALS_WIDTH, MM.TOTALS_HEIGHT / 6, 'f');
    wellCloseReport.rect(MM.TOTALS_LEFT, MM.TOTALS_TOP, MM.TOTALS_WIDTH, MM.TOTALS_HEIGHT);
    equalGrid(MM.TOTALS_LEFT, MM.TOTALS_TOP, MM.TOTALS_WIDTH, MM.TOTALS_HEIGHT, MM.TOTALS_ROWS, MM.TOTALS_COLUMNS, wellCloseReport);
    wellCloseReport.setFontStyle('bold');
    textArrayInBoxes(headers, MM.TOTALS_LEFT, MM.TOTALS_TOP, MM.TOTALS_WIDTH, MM.TOTALS_HEIGHT, 'center', wellCloseReport);
    wellCloseReport.setFontStyle('normal');
    textArrayInBoxes(data, MM.TOTALS_LEFT, MM.TOTALS_TOP, MM.TOTALS_WIDTH, MM.TOTALS_HEIGHT, 'center', wellCloseReport);

};

const drawProductsTable = (wellCloseReview: IWellCloseReview, startIndex:number, productReport: jsPdf) => {
    const headerArr = [[
        'Product',
        'Size',
        'Unit',
        'Price',
        'Total Received',
        'Total Adjusted',
        'Total Returned',
        'Total Used',
        'Closing',
        'Credited',
        'Diff (Amt)',
        'Diff ($)',
        'Diff (%)',
        'Final (Amt)',
        'Final ($)',
    ]];
    const dataArr = [[undefined]] as any;
    let i = startIndex;
    const numRows = startIndex === 0 ? MM.PRODUCTS_ROWS - 1 : MM.DATA_ROWS - 1;
    const piArr = wellCloseReview.products;
    
    for (;i < piArr.length && i - startIndex < numRows; i++) {
        const ip = piArr[i];
        const tempRow = [
            ip.product.name,
            ip.product.size,
            ip.product.unit,
            mask.currency(ip.price),
            ip.totalReceived,
            ip.totalAdjusted,
            ip.totalReturned,
            ip.totalUsed,
            ip.closingAmount,
            ip.credited,
            ip.difference,
            mask.currency(ip.totalCost),
            finalDifferenceValue(ip).toFixed(2) + '%',
            usedRecValue(ip),
            mask.currency(finalUsedValue(ip)),
        ];
        dataArr.push(tempRow);
    }
    fillEmptyRows(headerArr, numRows);
    fillEmptyRows(dataArr, numRows);
    productReport.setFillColor(MM.HEADER_COLOR);
    const tempTop = startIndex === 0 ? MM.PRODUCTS_TOP : MM.DATA_TOP;
    const tempHeight = startIndex === 0 ? MM.PRODUCTS_HEIGHT : MM.DATA_HEIGHT;
    productReport.rect(MM.PRODUCTS_LEFT, tempTop, MM.PRODUCTS_WIDTH, tempHeight / numRows, 'f');
    productReport.rect(MM.PRODUCTS_LEFT, tempTop, MM.PRODUCTS_WIDTH, tempHeight);
    productReport.setFontStyle('bold');
    textArrayInBoxes(headerArr, MM.PRODUCTS_LEFT, tempTop, MM.PRODUCTS_WIDTH, tempHeight, 'left', productReport);
    equalGrid(MM.PRODUCTS_LEFT, tempTop, MM.PRODUCTS_WIDTH, tempHeight, numRows, MM.PRODUCTS_COLUMNS, productReport);
    productReport.setFontStyle('normal');
    textArrayInBoxes(dataArr, MM.PRODUCTS_LEFT, tempTop, MM.PRODUCTS_WIDTH, tempHeight, 'left', productReport);
    return i;
};

const usedRecValue = (wcp: IWellCloseReviewProduct) => {
    const usedRec = wcp.totalUsed + wcp.difference;
    return usedRec;
};

const finalUsedValue = (wcp: IWellCloseReviewProduct) => {
    const usedRec = wcp.totalUsed + wcp.difference;
    const finalUsed = usedRec * wcp.price;
    return finalUsed;
};

const finalDifferenceValue = (wcp: IWellCloseReviewProduct) => {
    const diffPercent = wcp.difference / wcp.totalUsed;

    return isFinite(diffPercent) ? diffPercent : 0;
};


const drawExpenseTable = (wellCloseReview: IWellCloseReview, startIndex:number, productReport: jsPdf) => {
    const headerArr = [[
        'Expense',
        'Type',
        'Unit Price',
        'Total Units',
        'Total Price',
        'Adjustments',
        'Difference ($)',
        'Final (Units)',
        'Final ($)',
    ]];
    const dataArr = [[undefined]] as any;
    let i = startIndex;
    const numRows = startIndex === 0 ? MM.PRODUCTS_ROWS - 1 : MM.DATA_ROWS - 1;
    const piArr = wellCloseReview.expenses;
    
    for (;i < piArr.length && i - startIndex < numRows; i++) {
        const ip = piArr[i];
        const tempRow = [
            ip.expenseType.name,
            ip.expenseType.isRental ? 'Rental' : 'Service',
            mask.currency(ip.unitPrice),
            ip.totalUnits,
            mask.currency(ip.totalPrice),
            ip.adjustments,
            ip.differencePrice,
            ip.finalUnits,
            mask.currency(ip.finalPrice),
        ];
        dataArr.push(tempRow);
    }
    fillEmptyRows(headerArr, numRows);
    fillEmptyRows(dataArr, numRows);
    productReport.setFillColor(MM.HEADER_COLOR);
    const tempTop = startIndex === 0 ? MM.PRODUCTS_TOP : MM.DATA_TOP;
    const tempHeight = startIndex === 0 ? MM.PRODUCTS_HEIGHT : MM.DATA_HEIGHT;
    productReport.rect(MM.PRODUCTS_LEFT, tempTop, MM.PRODUCTS_WIDTH, tempHeight / numRows, 'f');
    productReport.rect(MM.PRODUCTS_LEFT, tempTop, MM.PRODUCTS_WIDTH, tempHeight);
    productReport.setFontStyle('bold');
    textArrayInBoxes(headerArr, MM.PRODUCTS_LEFT, tempTop, MM.PRODUCTS_WIDTH, tempHeight, 'left', productReport);
    equalGrid(MM.PRODUCTS_LEFT, tempTop, MM.PRODUCTS_WIDTH, tempHeight, numRows, MM.EBP_COLUMNS, productReport);
    productReport.setFontStyle('normal');
    textArrayInBoxes(dataArr, MM.PRODUCTS_LEFT, tempTop, MM.PRODUCTS_WIDTH, tempHeight, 'left', productReport);
    return i;
}; 


// WEBPACK FOOTER //
// ./src/Services/Pdf/WellCloseSnapshot/DrawWellCloseSnapshot.ts